import React, { useCallback, useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Footer from "../Fotter";
import Header from "./header";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link, useNavigate } from "react-router-dom";
import { FiShoppingCart } from "react-icons/fi";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../redux/slices/AllProductSlice";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { toast } from "react-toastify";
import { AddWishlist } from "../redux/slices/AddWishlistSlice";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import endPoint from "../redux/EndPoint/endpoint";
import axios from "axios";

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [likedProducts, setLikedProducts] = useState(new Set());
  const { AllData } = useSelector((state) => state.product);
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [categoryDataMap, setCategoryDataMap] = useState({});
  const { AllCategory } = useSelector((state) => state.category);
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!AllData?.products || AllData?.products?.length === 0) {
      const fetchData = async () => {
        setLoading(true);
        try {
          await dispatch(fetchProducts()).unwrap();
        } catch (error) {
          console.log("Error", error);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    } else {
      setLoading(false);
    }
  }, [AllData?.products, dispatch]);

  const toggleLike = useCallback(
    (productId) => {
      dispatch(AddWishlist(productId));
      setLikedProducts((prevLikedProducts) => {
        const updatedLikes = new Set(prevLikedProducts);
        if (updatedLikes.has(productId)) {
          updatedLikes.delete(productId);
        } else {
          updatedLikes.add(productId);
        }
        return updatedLikes;
      });
    },
    [dispatch]
  );

  const handleAddToCart = useCallback((item) => {
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      } else {
        toast.error("Responce Error!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      }
    });
  });

  const generateSlug = useCallback((text) => {
    if (!text) return "";

    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\- ]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  });

  const bannerImages = [
    {
      to: `https://www.addmecart.com/topSale/smart-phone-tab/apple-iphones/apple-iphone-16-plus-pink-128-gb`,
      src: require("../../components/assets/Banners/IPhone/7.png"),
      alt: "iPhone Banner",
    },
    {
      to: `https://www.addmecart.com/remotesale/audio-video-accessories/fire-stick/amazon-fire-tv-stick-with-alexa-voice-remote-includes-tv-and-app-controls`,
      src: require("../../components/assets/Banners/Remote/Fire TV Stick Remote 1.png"),
      alt: "Remote Banner",
    },
    {
      to: `https://www.addmecart.com/acsale/home-electronics/air-conditioner/lloyd-stellar-6-in-1-convertible-2024-model-15-ton-5-star-white-gls18v5fwssl-copper-condenser`,
      src: require("../../components/assets/Banners/Ac/Lloyd AC 1.png"),
      alt: "AC Banner",
    },
    {
      to: `https://www.addmecart.com/watchsale/watches/smartwatches/fire-boltt-4g-pro-volte-calling-smart-watch-202-tft-display-4g-nano-sim-gps-400mah-battery-blue`,
      src: require("../../components/assets/Banners/Watchs/Fire Bolt 4g Pro Smartwatch 1.png"),
      alt: "Watch Banner",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  useEffect(() => {
    if (hasFetched || !AllCategory || AllCategory.length === 0) return;

    const loadInitialData = async () => {
      try {
        setLoading(true);
        const selected = [...AllCategory].sort(() => 0.5 - Math.random());
        const newCategoryDataMap = {};
        let validCount = 0;

        for (const cat of selected) {
          if (validCount >= 10) break;

          try {
            const res = await axios.get(
              `${endPoint.GETCATEGORYDATA}/${encodeURIComponent(cat.name)}`
            );

            if (
              res?.data &&
              Array.isArray(res.data.products) &&
              res.data.products.length >= 10
            ) {
              newCategoryDataMap[cat.name] = res.data;
              validCount++;
            }
          } catch (error) {
            console.error(`Category error: ${cat.name}`, error.message);
          }
        }

        setCategoryDataMap(newCategoryDataMap);
        setHasFetched(true);
      } catch (err) {
        console.error("Unexpected error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, [AllCategory?.length, hasFetched]);

  const getCategoryIdByName = (categoryName) => {
    const matched = AllCategory.find((cat) => cat.name === categoryName);
    return matched ? matched._id : null;
  };

  const handleCategoryClick = (categoryName) => {
    const categoryId = getCategoryIdByName(categoryName);

    if (categoryId) {
      navigate(`/product-category/${categoryName}/${categoryId}`, {
        state: { categoryName, categoryId },
      });
    } else {
      console.warn("Category not found for name:", categoryName);
    }
  };

  return (
    <div>
      <Header />
      <div className="flex flex-col min-h-screen">
        <div className="flex-grow">
          <div className="w-[90%] mx-auto mb-6 mt-7">
            <Slider {...settings}>
              {bannerImages.map((banner, index) => (
                <a
                  key={index}
                  href={banner?.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="overflow-hidden block"
                >
                  <img
                    src={banner.src}
                    alt={banner.alt}
                    className="w-full h-[180px] sm:h-[240px] md:h-[300px] lg:h-[400px] transition-transform duration-300 ease-in-out "
                  />{" "}
                </a>
              ))}
            </Slider>
          </div>

          <div className={"w-full items-center mx-auto bg-white p-1 mb-10"}>
            {loading ? (
              <div className="text-center py-10 font-semibold text-xl">
                Loading data...
              </div>
            ) : (
              <div className="sm:w-[92%] w-[98%] mx-auto ">
                {Object.entries(categoryDataMap).length >= 2 && (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 ">
                    {Object.entries(categoryDataMap)
                      .slice(0, 10)
                      .map(([categoryName, categoryData]) => (
                        <div key={categoryName} className=" p-4 bg-gray-50 ">
                          <div className="flex items-center gap-2 mb-4 justify-between">
                            <h2 className="text-xl md:text-2xl font-bold">
                              {categoryName}
                            </h2>
                            <div className="flex justify-center items-center">
                              <div
                                onClick={() =>
                                  handleCategoryClick(categoryName)
                                }
                                className="sm:w-8 sm:h-8 w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center shadow-md hover:bg-blue-800 cursor-pointer transition"
                              >
                                <span className="text-lg text-white">﹥</span>
                              </div>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 sm:grid-cols-2 gap-3">
                            {categoryData?.products?.slice(0, 4).map((item) => (
                              <div
                                key={item._id}
                                className="relative border border-gray-300 rounded-md p-2 hover:scale-105 transition-transform"
                              >
                                <Link
                                  to={`/shop/${generateSlug(
                                    item?.category
                                  )}/${generateSlug(
                                    item?.subcategory
                                  )}/${generateSlug(item?.title)}`}
                                  state={{ item }}
                                >
                                  <img
                                    src={item?.images?.productimage1}
                                    alt={item.title}
                                    className="w-full h-28 sm:h-36 object-contain"
                                  />
                                </Link>
                                <button
                                  className="absolute top-2 left-2"
                                  onClick={() => toggleLike(item._id)}
                                >
                                  {likedProducts.has(item._id) ? (
                                    <FaHeart className="text-red-500 text-sm " size={20} />
                                  ) : (
                                    <FaRegHeart className="text-gray-400 text-sm " size={20} />
                                  )}
                                </button>

                                <button
                                  onClick={() => handleAddToCart(item)}
                                  className="absolute top-2 right-2 bg-gray-100 p-1 rounded-full"
                                >
                                  <FiShoppingCart className="text-gray-800 text-base" size={20} />
                                </button>

                                <Link
                                  to={`/shop/${generateSlug(
                                    item?.category
                                  )}/${generateSlug(
                                    item?.subcategory
                                  )}/${generateSlug(item?.title)}`}
                                  state={{ item }}
                                >
                                  <h3 className="text-sm font-semibold mt-2 truncate">
                                    {item.title}
                                  </h3>
                                  {/* <p className="text-xs text-gray-500 truncate">
                                    {item.description}
                                  </p> */}
                                  <div className="sm:flex item-center sm:justify-between gap-2 text-sm mt-1">
                                    <div className="flex items-center gap-2 text-sm mt-1">
                                      <span className="font-bold">
                                        ₹{item.salePrice}
                                      </span>
                                      <span className="line-through text-gray-400">
                                        ₹{item.regularPrice}
                                      </span>
                                    </div>
                                    {item?.isCodeAvailable &&
                                      <span className="text-green-600 text-bold text-gray-400 sm:ml-20 ml-0">
                                        COD Available
                                      </span>
                                    }
                                  </div>
                                </Link>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            )}
          </div>

          <button
            onClick={scrollToTop}
            className={`fixed bottom-5 right-5 border bg-gray-200 text-black font-semibold px-4 py-2 rounded-full shadow-lg transition-all duration-300 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-0"
              }`}
          >
            ⬆ Top
          </button>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
